import { selectCar } from './selectCar';

export const selectPeriod = (state) => {
  return selectCar(state).period;
};
